import { render, staticRenderFns } from "./seleted-payee.vue?vue&type=template&id=a0c5034a&scoped=true&"
import script from "./seleted-payee.vue?vue&type=script&lang=ts&"
export * from "./seleted-payee.vue?vue&type=script&lang=ts&"
import style0 from "./seleted-payee.vue?vue&type=style&index=0&id=a0c5034a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c5034a",
  null
  
)

component.options.__file = "seleted-payee.vue"
export default component.exports